import {$get,$post} from './main'

export function GetAllExamCategory(params){
  return new Promise((resolve)=>{
    $get('/webapi/Exam/GetAllExamCategory',params).then( res=> {
      resolve(res.data)
    })
  })
}
export function GetPaperList(params){
  return new Promise((resolve)=>{
    $get('/webapi/Exam/GetPaperList',params).then(res => {
      resolve(res.data)
    })
  })
}




// WEBPACK FOOTER //
// ./src/apis/exam.js